/**
 * @file   src/services/aiChatService.js
 * @brief  API service for AI Chat feature
 * @date   February, 2026
 * @author Jake Hokinson
 */
import { apiCall } from "./apiService";

const API_BASE = (process.env.REACT_APP_API_BASE_URL || "http://localhost:5200").replace(/\/+$/, "");

/**
 * Generate a want ad from chat messages via the AI endpoint
 * @param {Array} messages - Array of {role, content} objects
 * @param {string} adType - Ad type (default 'BUY')
 * @returns {Promise<Object>} - { aiMessage, wantAdData, followUpQuestion, isComplete }
 */
export const generateWantAd = async (messages, adType = "BUY") => {
  const url = `${API_BASE}/api/v2/ai-chat/generate-wantad`;
  const response = await apiCall(url, "POST", { messages, adType });
  return response?.data?.data || response?.data;
};

/**
 * Generate YouTube-style title + description from a finalized want-ad.
 * Called after the chat + form review are done.
 * @param {Object} wantAdData - finalized want-ad fields
 * @returns {Promise<Object>} - { adTitle, adDesc, fairHousingStatus }
 */
export const generateTitleAndDescription = async (wantAdData) => {
  const url = `${API_BASE}/api/v2/ai-chat/generate-title-description`;
  const response = await apiCall(url, "POST", { wantAdData });
  return response?.data?.data || response?.data;
};
